<script>
import { getEventUrl } from './api/activity'

export default {
  name: 'ActivityDispense',
  async beforeCreate() {
    let eventId = +this.$route.query.event_id
    if (!eventId) {
      this.$router.replace('/')
      return
    }
    try {
      let eventUrlData = await getEventUrl(eventId)
      if (eventUrlData.data && eventUrlData.data.url) {
        location.href = eventUrlData.data.url
      } else {
        this.$toast.show({
          text: '没有找到相关内容，请稍后再试',
          duration: 6000
        })
      }
    } catch (err) {
      this.$toast.show({
        text: err.response.data.message,
        duration: 6000
      })
    }
  },
  render: function(h) {
    return h() // avoid warning message
  },
}
</script>
